import React, {Fragment} from 'react';

const UpdateDoneRefreshStep = () => {
  return (
    <Fragment>
      <div>
        Your firmware is now up to date.<p/>
        you can close this TAB.<p/>&nbsp;<p/>
        </div>
    </Fragment>
  );
};

export default UpdateDoneRefreshStep;
